export enum KeyValuePairType {
  None = 0,
  TicketStatus = 1,
  TicketPriority = 2,
  TicketChannel = 3,
  TimelineActivityType = 11,
}
